<template class="app">
  <v-dialog class="rounded-xl" v-model="show" max-width="1500">
    <v-card>
      <v-toolbar color="primary">
        <v-toolbar-title class="white--text"> {{ $t('select_column_export') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click.stop="show = false" color="white">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <div v-if="loading" class="text-xs-center" style="min-height: 400px">
          <v-layout justify-center align-center row style="height: 400px">
            <v-flex>
              <div class="spinner text-xs-center">
                <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
              </div>
            </v-flex>
          </v-layout>
        </div>
        <v-layout v-else row wrap style="justify-content: space-around;">
          <v-flex xs12 md5 class="box">
            <div style="text-align: center;">
              <template>
                <h2 class="black--text">{{ $t('column_want_to_show') }}</h2>
                <draggable
                  class="used"
                  v-model="updateUsedList"
                  v-bind="dragOptions"
                  :move="onMove"
                  @start="isDragging"
                  @end="isDragging"
                  element="div"
                  :empty-insert-threshold="400"
                >
                  <transition-group type="transition" name="transitionUnused" tag="div">
                    <v-flex
                      style="display: inline-flex"
                      v-for="(element, index) in updateUsedList"
                      :key="`transitionUnuse_${index}`"
                    >
                      <template>
                        <div
                          style="margin: 10px 10px 0 0;display: flex; align-items: stretch;"
                          color="primary"
                        >
                          <v-btn
                            color="primary"
                            class="bFirst white--text"
                            :ripple="false"
                            max-width="40px"
                          >
                            <i class="fas fa-grip-vertical"></i>
                          </v-btn>
                          <v-btn
                            color="primary"
                            class="white--text bTwo text-xs-right"
                            :ripple="false"
                          >
                            {{ $t(element.text) }}
                          </v-btn>
                          <v-btn class="bLast" color="primary" icon @click="moveToUsed(element)">
                            <v-icon small color="white">close</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-flex>
                  </transition-group>
                </draggable>
              </template>
            </div>
          </v-flex>

          <v-flex d-flex md2 style="max-width: 4px;">
            <div class="hidden-sm-and-down" style="border-left: 2px solid #BDBDBD !important;" />
          </v-flex>

          <v-flex xs12 md5 class="box">
            <div style="text-align: center;">
              <template>
                <h2 class="black--text">{{ $t('column_do_not_show') }}</h2>
                <draggable
                  element="div"
                  v-model="updateUnUsedList"
                  v-bind="dragOptions"
                  :move="onMove"
                  class="unUsed"
                  :empty-insert-threshold="400"
                >
                  <transition-group tag="div" name="transitionUsed">
                    <v-flex
                      style="display: inline-flex;"
                      v-for="(element, index) in updateUnUsedList"
                      :key="`transitionUse_${index}`"
                    >
                      <template>
                        <div style="margin: 10px 10px 0 0;display: flex; align-items: stretch;">
                          <v-btn color="greyTheme" class="white--text bFirst" :ripple="false">
                            <i class="fas fa-grip-vertical"></i>
                          </v-btn>
                          <v-btn
                            color="greyTheme"
                            class="white--text bTwo text-xs-right"
                            :ripple="false"
                          >
                            {{ $t(element.text) }}
                          </v-btn>
                          <v-btn
                            class="bLast"
                            color="greyTheme"
                            icon
                            @click="moveTounUsed(element)"
                          >
                            <v-icon color="white" class="hidden-sm-and-down"
                              >keyboard_backspace</v-icon
                            >
                            <v-icon color="white" class="hidden-md-and-up">arrow_upward</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-flex>
                  </transition-group>
                </draggable>
              </template>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex>
            <v-radio-group v-model="ExcelType" row style="justify-content: center;">
              <v-radio :label="$t('merge_all')" value="merge" color="primary"></v-radio>
              <v-radio :label="$t('seperate_all')" value="separate" color="primary"></v-radio>
            </v-radio-group>

            <div class="text-xs-center">
              <v-btn
                color="primary"
                class="mr-2"
                outline
                :disabled="checkButton"
                @click="setDefault()"
              >
                <h3 class="primary--text">{{ $t('clear_all') }}</h3>
              </v-btn>
              <v-btn
                color="primary"
                :disabled="updateUsedList.length === 0"
                @click="putCustomExport()"
              >
                <h3 class="white--text">{{ $t('export_all') }}</h3>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import XLSX from 'xlsx'
import dayjs from 'dayjs'
import numeral from 'numeral'
export default {
  props: {
    value: Boolean,
    orderSum: []
  },
  components: {
    draggable
  },
  data() {
    return {
      loading: true,
      unUsedList: [],
      updateUnUsedList: [],
      UsedList: [
        { text: 'created_order_at', value: 'createAt', column: 'สร้างเมื่อ (Created Order at)' },
        { text: 'order_no', value: 'id', column: 'เลขที่การสั่งซื้อ (Order No.)' },
        { text: 'profile_name', value: 'fullName', column: 'ชื่อบัญชี (Profile Name)' },
        { text: 'created_order_by', value: 'created_by', column: 'สร้างโดย (Created Order by)' },
        { text: 'order_status', value: 'status', column: 'สถานะ (Order Status)' },
        { text: 'payment_method', value: 'payment', column: 'วิธีการชำระเงิน (Payment Method)' },
        {
          text: 'transaction_id',
          value: 'transactionid',
          column: 'หมายเลขอ้างอิง (Transaction ID)'
        },
        { text: 'image_slip', value: 'imageSlip', column: 'หลักฐานการชำระเงิน (Image Slip)' },

        { text: 'product_name', value: 'productName', column: 'ชื่อสินค้า (Product Name)' },
        {
          text: 'product_option',
          value: 'productOption',
          column: 'ตัวเลือกสินค้า (Product Option)'
        },
        { text: 'product_sku', value: 'productSKU', column: 'รหัสสินค้า (SKU)' },
        { text: 'product_quantity', value: 'productQuantity', column: 'จำนวน (Quantity)' },
        { text: 'product_price', value: 'productPrice', column: 'ราคาสินค้า (Product Price)' },
        { text: 'shipping_fee', value: 'shippingcharge', column: 'ค่าส่ง (Shipping Fee)' },
        { text: 'coupon_code', value: 'couponCode', column: 'รหัสโค้ดส่วนลด (Coupon Code)' },
        { text: 'coupon_discount', value: 'discount', column: 'ส่วนลด (Coupon Discount)' },
        {
          text: 'price_per_unit',
          value: 'price_per_unit',
          column: 'ราคาต่อหน่วย (Price Per Unit)'
        },
        { text: 'total', value: 'afterDiscount', column: 'ยอดรวมทั้งสิ้น (Total)' },
        {
          text: 'tax_info',
          value: 'taxInfo',
          column: 'ข้อมูลในการออกใบเสร็จ/ใบกำกับภาษี (Receipt/ Tax invoice info)'
        },
        { text: 'tax_id', value: 'taxID', column: 'หมายเลขประจำตัวผู้เสียภาษี (Tax ID)' },
        { text: 'address', value: 'nameaddress', column: 'ชื่อ-ที่อยู่ผู้รับ (Address)' },
        { text: 'customer_name', value: 'customerName', column: 'ชื่อผู้รับ (Customer Name)' },
        { text: 'house_no', value: 'houseNo', column: 'บ้านเลขที่ (House No.)' },
        { text: 'sub_district', value: 'subDistrict', column: 'แขวง/ตำบล (Subdistrict)' },
        { text: 'district', value: 'disTrict', column: 'เขต/อำเภอ (District)' },
        { text: 'province', value: 'proVince', column: 'จังหวัด (Province)' },
        { text: 'postCode', value: 'postCode', column: 'รหัสไปรษณีย์ (Postcode)' },
        { text: 'phone', value: 'telNo', column: 'เบอร์โทรศัพท์ (Phone)' },
        { text: 'shipping_type', value: 'shippingtype', column: 'ช่องทางการจัดส่ง(Shipping)' },
        { text: 'tracking_no', value: 'trackingno', column: 'เลขพัสดุ(Tracking No.)' },
        { text: 'remark', value: 'remark', column: 'หมายเหตุ (Remark)' },
        { text: 'sellChannel', value: 'sellChannel', column: 'ช่องทางการสั่งซื้อ (Channel)' },
        {
          text: 'payment_slip_transaction_id',
          value: 'ref_no',
          column: 'หมายเลขอ้างอิงสลิป(Payment Slip Transaction ID)'
        },
        {
          text: 'payment_slip_create_date',
          value: 'payment_time',
          column: 'วันที่โอนเงิน(Payment Slip Create Date)'
        }
      ],
      updateUsedList: [],
      btnGroup: 2,
      customOrderSum: this.orderSum,
      getOrderSum: [],
      ExcelType: 'merge',
      checkButton: false
    }
  },
  async mounted() {
    const vm = this
    let dataAddon = []
    try {
      if (vm.selectedBot.shop_addon_form_status) {
        let jsonDataAddon = JSON.parse(vm.selectedBot.shop_addon_form_json)
        jsonDataAddon.forEach((item, index) => {
          if (index > 1) {
            if (item.is_require != 'close') {
              if (item['label'] != 'Tel.') {
                dataAddon.push({
                  text: item.label,
                  value: item.label,
                  column: item.label
                })
              }
            }
          }
        })
        vm.UsedList = vm.UsedList.concat(dataAddon)
      }
    } catch (error) {
      console.log(error)
    }
    vm.getCustomExport()
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: ''
      }
    },
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    async setDefault() {
      const vm = this
      vm.checkButton = true
      vm.updateUnUsedList = vm.unUsedList
      vm.updateUsedList = vm.UsedList
      vm.moveToUsed()
      vm.moveTounUsed()
    },
    async checkDefault() {
      const vm = this
      vm.checkButton = false
      if (vm.updateUsedList.length === vm.UsedList.length) {
        vm.checkButton = true
      }

      if (_.isEqual(vm.updateUsedList, vm.UsedList) != true) {
        vm.checkButton = false
      } else {
        vm.checkButton = true
      }
    },
    async getCustomExport() {
      const vm = this
      const data = {
        pageId: vm.selectedBot.pageid
      }
      vm['getOrderSum'] = vm.customOrderSum
      let response = await vm.get(
        `page/${data.pageId}/custom-export-config?custom_type=order_excel`
      )
      if (response.success) {
        if (response.result != null && response.result.content_data != null) {
          vm.loading = false
          const data = response.result
          let getData = {}
          try {
            getData = JSON.parse(data.content_data)
          } catch (error) {
            console.log('data is null')
          }

          vm['getOrderSum'] = vm['getOrderSum'].map(item => {
            let getDay = item.timestamp
            let day = ''
            day = dayjs(getDay).format('DD/MM/YYYY HH:MM')
            item.createAt = day ? day : '-'
            item.fullName = `${item.first_name} ${item.last_name}`
            item.imageSlip = item.note ? item.note : '-'

            try {
              let jsondata = JSON.parse(item.jsonvalue)

              item.couponCode = jsondata.promocode ? jsondata.promocode : '-'
            } catch (error) {
              item.couponCode = '-'
            }
            try {
              let addressJson = JSON.parse(item.address_json)
              item.taxInfo = addressJson.tax_address ? addressJson.tax_address : '-'
              item.taxID = addressJson.tax_id ? addressJson.tax_id : '-'
            } catch (error) {
              item.taxInfo = '-'
            }
            let customerInfo = item['nameaddress'] ? item['nameaddress'].split(', ') : []
            item.customerName = customerInfo[0] ? customerInfo[0].trim() : '-'
            item.houseNo = customerInfo[1] ? customerInfo[1].trim() : '-'
            item.subDistrict = customerInfo[2] ? customerInfo[2].trim() : '-'
            item.disTrict = customerInfo[3] ? customerInfo[3].trim() : '-'
            item.proVince = customerInfo[4] ? customerInfo[4].trim() : '-'
            item.postCode = customerInfo[5] ? customerInfo[5].trim() : '-'
            item.telNo = customerInfo[customerInfo.length - 1]
            item.sellChannel = item.app
            try {
              item.products = JSON.parse(item.productdetail)
            } catch (error) {
              console.log(error)
            }
            let disCount = parseFloat(item.discount)
            let total = parseFloat(item.total)

            let afterDiscount = item.afterDiscount
            afterDiscount = total - (disCount ? disCount : 0)
            item.afterDiscount = afterDiscount.toFixed(2)
            item.created_by = `${item.created_by_type}|${item.fullName}`
            item.trackingno = item.trackingno ? item.trackingno : '-'
            item.sellChannel = item.app ? item.app : '-'
            item.price_per_unit =
              Number(total) &&
              Number(total) > 0 &&
              Number(item.allquantity) &&
              Number(item.allquantity) > 0
                ? numeral(Math.round((Number(item.total) / Number(item.allquantity)) * 100) / 100)
                    .format('0,0.00')
                    .toString()
                : 0
            if (item.k_bank_verify_slip_json) {
              const kBankJson = JSON.parse(item.k_bank_verify_slip_json)
              const date =
                kBankJson && kBankJson.bank_transfer_date
                  ? dayjs(kBankJson.bank_transfer_date).format('DD/MM/YYYY') + ' '
                  : ''
              const time =
                kBankJson && kBankJson.bank_transfer_time ? kBankJson.bank_transfer_time : ''
              item.payment_time = date + time
              item.ref_no = kBankJson.ref_no
            } else {
              item.ref_no = ''
              item.payment_time = ''
            }

            const status = item.status
              ? this.$t(item.status)
                  .charAt(0)
                  .toUpperCase() + this.$t(item.status).slice(1)
              : ''
            return { ...item, status }
          })
          try {
            vm.updateUsedList = getData.data
            vm.updateUnUsedList = vm.UsedList
            vm.moveTounUsed()
          } catch (error) {
            console.log(error)
          }
          vm.ExcelType = getData.type
          vm.checkDefault()
        } else {
          vm.loading = false
          vm.updateUsedList = vm.UsedList
        }
      }
    },
    async putCustomExport() {
      const vm = this
      const data = {
        pageId: vm.selectedBot.pageid,
        body: {
          custom_type: 'order_excel',
          content_data: { data: vm.updateUsedList, type: vm.ExcelType }
        }
      }
      let response = await vm.put(
        `page/${data.pageId}/custom-export-config?custom_type=order_excel`,
        data.body
      )

      if (response.success) {
        vm.setting = response.result
        vm.exportCustomExcel()
      }
    },
    async exportCustomExcel() {
      const vm = this
      let filename = ''
      let dataWS = null
      let array = []
      let json = {}

      for (let index = 0; index < vm['getOrderSum'].length; index++) {
        const element = vm['getOrderSum'][index]

        let elementValue = vm.getValue(element)
        if (elementValue && elementValue.data) {
          array.push(elementValue.data)
        }
        if (elementValue && elementValue.array && elementValue.array.length > 0) {
          elementValue.array.map(item => {
            array.push(item)
          })
        }
      }
      json = array

      filename = 'zwizshop'
      dataWS = XLSX.utils.json_to_sheet(json)

      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    getValue(element) {
      const vm = this
      let data = {}
      let array = []
      let elementUsedList = vm.updateUsedList
      for (const item of elementUsedList) {
        data[vm.$t(item.column)] = element[item.value]
        try {
          let addonValue = JSON.parse(element.shop_addon_value_json)
          if (addonValue) {
            addonValue.forEach(value => {
              if (item.column === value.label) {
                data[vm.$t(item.column)] = value.message
              }
            })
          }
        } catch (error) {
          console.log(error)
        }

        if (vm.ExcelType == 'merge') {
          let productName = []
          let productOption = []
          let productSku = []
          let productQuantity = []
          let productPrice = []
          let products = element.products

          if (typeof products == 'object' && products.length > 0) {
            let sum = 0
            let getPrice = []
            products.map(function(product) {
              productName.push(product.name)
              productOption.push(product.option)
              productSku.push(product.sku)
              productQuantity.push(product.quantity)
              getPrice = product.price
              sum += getPrice
            })
            productPrice.push(sum)
          }

          if (item.value === 'productName') {
            data[vm.$t(item.column)] = productName.toString()
          }
          if (item.value === 'productOption') {
            data[vm.$t(item.column)] = productOption.toString()
          }
          if (item.value === 'productSKU') {
            data[vm.$t(item.column)] = productSku.toString()
          }
          if (item.value === 'productQuantity') {
            data[vm.$t(item.column)] = productQuantity.toString()
          }
          if (item.value === 'productPrice') {
            data[vm.$t(item.column)] = productPrice.toString()
          }
          if (item.value === 'productPrice') {
            data[vm.$t(item.column)] = productPrice.toString()
          }
        } else if (vm.ExcelType == 'separate') {
          let productName = []
          let productOption = []
          let productSku = []
          let productQuantity = []
          let productPrice = []
          let products = element.products

          if (typeof products == 'object' && products.length > 0) {
            let sumPrice = 0
            let sumQua = 0
            let getPrice = []
            let getQua = []
            products.map(function(product) {
              productName.push(product.name)
              productOption.push(product.option)
              productSku.push(product.sku)
              getQua = product.quantity
              getPrice = product.price
              sumQua += getQua
              sumPrice += getPrice
            })
            productQuantity.push(sumQua)
            productPrice.push(sumPrice)
          }
          if (element.products && element.products.length > 0) {
            if (item.value === 'productName') {
              data[vm.$t(item.column)] = productName.toString()
            }
            if (item.value === 'productOption') {
              data[vm.$t(item.column)] = productOption.toString()
            }
            if (item.value === 'productSKU') {
              data[vm.$t(item.column)] = productSku.toString()
            }
            if (item.value === 'productQuantity') {
              data[vm.$t(item.column)] = productQuantity.toString()
            }
            if (item.value === 'productPrice') {
              data[vm.$t(item.column)] = productPrice.toString()
            }
          }
        }
      }

      if (element.products && element.products.length > 0 && vm.ExcelType == 'separate') {
        element.products.forEach((value, index) => {
          if (index >= 0) {
            let product = {}
            if ('ชื่อสินค้า (Product Name)' in data) {
              product['ชื่อสินค้า (Product Name)'] = value.name
            }
            if ('ตัวเลือกสินค้า (Product Option)' in data) {
              product['ตัวเลือกสินค้า (Product Option)'] = value.option
            }
            if ('รหัสสินค้า (SKU)' in data) {
              product['รหัสสินค้า (SKU)'] = value.sku
            }
            if ('จำนวน (Quantity)' in data) {
              product['จำนวน (Quantity)'] = value.quantity
            }
            if ('ราคาสินค้า (Product Price)' in data) {
              product['ราคาสินค้า (Product Price)'] = value.price
            }
            if ('ราคาสินค้า (Product Price)' in data) {
              product['ราคาสินค้า (Product Price)'] = value.price
            }
            array.push(product)
          }
        })
      }

      return { data: data, array: array }
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    },
    isDragging(e) {
      const vm = this
      const { item, type } = e
      vm.checkDefault()

      if (e.oldIndex != e.newIndex) {
        vm.checkButton = false
      }
    },
    moveTounUsed(e) {
      const vm = this
      if (!e) {
        vm.updateUnUsedList = vm.updateUnUsedList.filter(function(objFromA) {
          return !vm.updateUsedList.find(function(objFromB) {
            return objFromA.text === objFromB.text
          })
        })
      } else {
        vm.updateUsedList.push(e)
        vm.updateUnUsedList = vm.updateUnUsedList.filter(function(objFromA) {
          return !vm.updateUsedList.find(function(objFromB) {
            return objFromA.text === objFromB.text
          })
        })
      }
      vm.checkDefault()
    },
    moveToUsed(e) {
      const vm = this
      if (!e) {
        vm.updateUsedList = vm.updateUsedList.filter(function(objFromA) {
          return !vm.updateUnUsedList.find(function(objFromB) {
            return objFromA.text === objFromB.text
          })
        })
      } else {
        vm.updateUnUsedList.push(e)
        vm.updateUsedList = vm.updateUsedList.filter(function(objFromA) {
          return !vm.updateUnUsedList.find(function(objFromB) {
            return objFromA.text === objFromB.text
          })
        })
      }
      vm.checkDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  justify-content: center;
}
.box {
  margin-bottom: 4rem;
  min-height: 200px;
  max-height: 350px;
  min-width: 200px;
  max-width: 600px;
  padding: 0 6px 0 6px;
}
::-webkit-scrollbar {
  appearance: none;
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.greyTheme {
  background-color: #bdbdbd !important;
}
.draggable {
  transition: all 0 ease-in-out;
}
.bFirst {
  width: 30px;
  border-radius: 10px 0px 0px 10px !important;

  cursor: move;
  padding: 0 !important;
}
.bTwo {
  border-radius: 0 !important;
  border-left: 4px solid white !important;
  border-right: 4px solid white !important;
}
.bLast {
  display: inline-block;

  border-radius: 0px 10px 10px 0px !important;
}
.display-none {
  display: none !important;
  transition: 0s !important;
}
.used {
  display: flex;
  justify-content: center;
  max-height: 280px;
  min-height: 200px;
  overflow: auto;
}
.unUsed {
  display: flex;
  justify-content: center;
  min-height: 200px;
  max-height: 280px;
  overflow: auto;
}
.transitionUsed {
  max-height: 200px;
  min-width: 200px;
}
.transitionUsed:focus-visible {
  max-height: 200px;
  min-width: 200px;
}
.transitionUsed-enter-active,
.transitionUsed-leave-active {
  display: none !important;
  transition: 0s !important;
}
.transitionUnused-enter-active,
.transitionUnused-leave-active {
  display: none !important;
  transition: 0s !important;
}
.v-btn {
  margin: 0;
  min-width: 0;
}
.bTwo,
.v-btn__content {
  cursor: all-scroll;
}
.v-btn.bLast {
  cursor: pointer;
}
.v-btn:not(.v-btn--depressed):not(.v-btn--flat):active {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
  will-change: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.theme--light.v-btn.v-btn--disabled,
.theme--light.v-btn.v-btn--disabled .v-btn__loading,
.theme--light.v-btn.v-btn--disabled .v-icon {
  color: rgba(0, 0, 0, 0.4) !important;
}
.theme--light.v-btn.v-btn--disabled .v-btn__content > h3 {
  color: rgba(0, 0, 0, 0.4) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/components/CustomOrderSummary.vue